<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/axGLXZ/tc-custom/9781591812258.jpg?1706906234490" alt="This image is the cover for the book What Is Self?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What Is Self?
      </h1>
      <p class="bookDescription body article font2">
        <b>The renowned contemporary mystic and author of <i>The Experience of No-Self</i> presents her philosophical treatise on the nature of Self and God.</b><br/>  <br/> As a Carmelite nun, Bernadette Roberts pursued a life in union with God. She wrote compellingly about her contemplative spiritual journey in her memoirs <i>The Experience of No-Self</i> and <i>The Path of No-Self</i>. Now she builds on the wisdom she gained, exploring the ultimate consciousness that transcends self and experience.<br/>  <br/> In <i>What Is Self?</i>, Ms. Roberts explains her conceptions of the ego, the self, and the revelations of the contemplative life. Deeply personal and profoundly spiritual, this latest effort puts all of Bernadette’s insights into clearer and sharper perspective—as though her own journey has grown clearer with distance. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bernadette Roberts
      </h2>
      
      <p class="authorDescription body article">Bernadette Roberts is one of the most extraordinary contemplatives of our time. The child of a devout Catholic family, Bernadette Roberts’s contemplative experiences began at an early age. At fifteen, they began to fit into a frame of reference within her Christian tradition. Ten years of seclusion in a monastery followed, during which Bernadette realized an abiding state of oneness with God. According to the Christian mystical tradition, this egoless, unitive state is as far as one can progress in this life.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sentient Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?645646d0